module.exports = __webpack_public_path__ + "static/media/print.b8c116ac.svg";